module.exports = {
  "dof-switch-wrapper": {
    "position": "relative",
    "width": "96",
    "height": "48",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "dof-switch-loading": {
    "width": "48",
    "height": "48",
    "position": "absolute",
    "left": "32",
    "top": "0"
  },
  "switch": {
    "width": "96",
    "height": "48",
    "borderStyle": "solid",
    "borderWidth": "4",
    "borderRadius": "24",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "switch-colmo": {
    "borderWidth": "2"
  },
  "switch-white": {
    "width": "96",
    "height": "48",
    "borderStyle": "solid",
    "borderColor": "#ffffff",
    "backgroundColor": "#1e2e37",
    "borderWidth": "4",
    "borderRadius": "24",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "switch-disabled": {
    "opacity": 0.3
  },
  "switch-dot": {
    "borderRadius": "8",
    "width": "16",
    "height": "16",
    "position": "relative",
    "left": "12",
    "transformOrigin": "center",
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "switch-white-dot": {
    "borderRadius": "8",
    "width": "16",
    "height": "16",
    "position": "relative",
    "left": "12",
    "backgroundColor": "rgba(0,0,0,0)"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-a1eea166!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-switch/index.vue
// module id = 531
// module chunks = 0 1